module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-19-e212d7827be626785d18f9eb3a91ee6f.svg";